import { Trans } from 'react-i18next';
import i18n from 'locales/i18n';
import { HorizontalRateChartDataItem } from '@components/report/chart/horizontal-rate-chart/HorizontalRateChart';

import { TTReportRes, TTContentViewPerLength } from '@apis/orval/model';

import round, { roundFloat } from '@utils/round';

import { ContentTtProps } from './ContentTt';

export class ContentTtAdapter {
	value: TTReportRes;

	constructor(value: TTReportRes) {
		this.value = value;
	}

	get bannerHashtags() {
		const mainHashTags = this.value?.content?.main_hashtags ?? [];

		return (mainHashTags.map((i) => i) as string[]).slice(0, 5);
	}

	timeUnitMapper = {
		sec: i18n?.t(
			'infReportTiktok:features.report.section-content.tt.content-tt.content-tt-adapter.time-unit.sec',
		), //'초',
		min: i18n?.t(
			'infReportTiktok:features.report.section-content.tt.content-tt.content-tt-adapter.time-unit.min',
		), //'분',
		hour: i18n?.t(
			'infReportTiktok:features.report.section-content.tt.content-tt.content-tt-adapter.time-unit.hour',
		), //'시간',
		day: i18n?.t(
			'infReportTiktok:features.report.section-content.tt.content-tt.content-tt-adapter.time-unit.day',
		), // '일',
		month: i18n?.t(
			'infReportTiktok:features.report.section-content.tt.content-tt.content-tt-adapter.time-unit.month',
		), //'월',
		year: i18n?.t(
			'infReportTiktok:features.report.section-content.tt.content-tt.content-tt-adapter.time-unit.year',
		), //'년',
	};

	get mainLengthName() {
		const start = this.value?.content?.main_video_length?.min_length?.value ?? '-';
		const end = this.value?.content?.main_video_length?.max_length?.value ?? '-';
		const unit =
			this.timeUnitMapper[
				this.value?.content?.main_video_length?.min_length?.unit ?? 'sec'
			];

		return `${start}~${end}${unit}`;
	}

	get mainLengthView() {
		const rate = this.value?.content?.main_video_length?.avg_view ?? undefined;
		return rate ? roundFloat(rate, 'down', 1) : undefined;
	}

	get viewPerLengthList() {
		return this.value?.content?.view_per_length ?? [];
	}

	getLengthName(viewPerLengthData: TTContentViewPerLength) {
		const start = viewPerLengthData?.min_length?.value ?? '-';
		const end = viewPerLengthData?.max_length?.value ?? '-';
		const unit = this.timeUnitMapper[viewPerLengthData?.min_length?.unit ?? 'sec'];

		return `${start}~${end}${unit}`;
	}

	get totalView() {
		return this.viewPerLengthList.reduce((acc, cur) => acc + (cur?.avg_view ?? 0), 0);
	}

	getDataFormat(viewPerLengthData: TTContentViewPerLength): HorizontalRateChartDataItem {
		return {
			label: this.getLengthName(viewPerLengthData),
			value: i18n?.t('unit.times', {
				number: viewPerLengthData?.avg_view
					? round(viewPerLengthData?.avg_view, 'down')
					: '-',
			}),
			isPositive: this.getLengthName(viewPerLengthData) === this.mainLengthName,
			valuePercentage: Math.round(
				((viewPerLengthData?.avg_view ?? 0) / this.totalView) * 100,
			),
		};
	}

	adapt(): ContentTtProps {
		return {
			bannerHashtags: this.bannerHashtags,
			contentViewPerLength: {
				desc: (
					<>
						{/* <span>{this.mainLengthName}</span> 길이의 콘텐츠 평균 조회 수가 <br />
						<span>{this.mainLengthView ? round(this.mainLengthView, 'down') : '-'} 회</span>로 가장{' '}
						<span>높습니다.</span> */}
						<Trans
							// t={i18n?.t}
							i18nKey={
								'infReportTiktok:features.report.section-content.tt.content-tt.content-type.content-view-per-length.description'
							}
							components={[
								<span key="main-length">{this.mainLengthName}</span>,
								<span key="realEngagement">
									{i18n?.t('unit.times', {
										number: this.mainLengthView
											? round(this.mainLengthView, 'down')
											: '-',
									})}
								</span>,
								<span key="high">
									{i18n?.t(
										'infReportTiktok:features.report.section-content.tt.content-tt.content-type.content-view-per-length.high',
									)}
								</span>,
							]}
						/>
					</>
				),
				data: this.viewPerLengthList.map((viewPerLengthData) =>
					this.getDataFormat(viewPerLengthData),
				),
			},
		};
	}
}
